import MaskedInputBase from "react-text-mask";
import { FormGroup } from "../../styles/FormGroup";

type MaskedInputProps = {
    name: string;
    mask: (string | RegExp)[];
    label?: string;
    onChange: (name: string, value: string) => void;
    onBlur?: (name: string, value: string) => void;
    value?: string;
    error?: string;
    required?: boolean;
    description?: string;
    [key: string]: any;
};

const   MaskedInput = ({
    name,
    label,
    onChange,
    mask,
    onBlur = null,
    required = false,
    value = "",
    error = "",
    description = "",
    ...props
}: MaskedInputProps) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        onChange(name, value);
    };

    const handleBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!onBlur) {
            return;
        }

        const { name, value } = e.target;
        onBlur(name, value);
    };

    return (
        <FormGroup $error={!!error} disabled={props.disabled} className={`form-group ${props?.className ?? ""}`}>
            {label ? (
                <label htmlFor={name}>
                    <span>
                        {label} {required ? " *" : ""}
                    </span>
                </label>
            ) : (
                ""
            )}

            <MaskedInputBase
                mask={mask}
                guide={false}
                id={name}
                name={name}
                placeholder={props.placeholder ?? ""}
                value={value}
                onChange={handleChange}
                onBlur={handleBlur}
                className="form-control"
                {...props}
            />
            <div>{description ? <small>{description}</small> : ""}</div>

            {error ? <span className="error">{error}</span> : ""}
        </FormGroup>
    );
};

export default MaskedInput;
